import RouterStore from "@/store/RouterStore";
import Configuracao from "../../misc/Configuracao";
import { VersaoMinutaDto } from "../../modelo/dto/VersaoMinutaDto";

class UrlsMinuta {

    config = Configuracao;

    // page/size continuam na query string (o Spring resolve Pageable direto dali). O restante do
    // filtro vai no corpo do POST (ver MinutaApi.listarMinutasAssinadas) — numerosProcesso pode ser
    // uma lista grande demais pra caber com segurança numa query string.
    minutasAssinadas(siglaGabinete: string, pagina: number, tamanhoPagina: number): string {
        const params = new URLSearchParams();
        params.set('page', `${pagina}`);
        params.set('size', `${tamanhoPagina}`);

        return this.config.urlBaseGE + `api/minutas/${siglaGabinete}/assinadas?${params.toString()}`;
    }

    listarMinutasComVotoVencido(siglaGabinete: string): string {
        return this.config.urlBaseGE + `api/minuta-voto-vencido/${siglaGabinete}`;
    }

    //MANTEM
    minutaComConteudo(idProcesso: number, idTipoMinuta: number, comConteudo: boolean, numeroMinuta?: number): string {

        const complementoConteudo = comConteudo ? '?conteudo=S' : '?conteudo=N'
        const complementoNumeroMinuta = numeroMinuta ? (comConteudo ? '&numeroMinuta=' : '?numeroMinuta=') + numeroMinuta : ''
        if (RouterStore.isPrd) {
            return this.config.urlMinuta + idProcesso + '/' + idTipoMinuta + complementoConteudo + complementoNumeroMinuta;
        }
        return this.config.urlMinutaGE + idProcesso + '/' + idTipoMinuta + complementoConteudo + complementoNumeroMinuta;
    }

    //MIGRADO
    minutaExternaComConteudo(idProcesso: number, numeroMinuta: number, comConteudo: boolean): string {

        const complementoConteudo = comConteudo ? '?comConteudo=true' : '?comConteudo=false'

        return this.config.urlMinutasExternas + idProcesso + '/' + numeroMinuta + complementoConteudo;
    }

    //MIGRADO, verificar com carrasco
    salvarConteudo(idProcesso: number, idTipoMinuta: number): string {
        if (RouterStore.isPrd) {
            return this.config.urlMinuta + idProcesso + '/' + idTipoMinuta + '/conteudo';
        }
        return this.config.urlMinutaGE + idProcesso + '/' + idTipoMinuta + '/conteudo';
    }

    //MANTEM
    salvarDados(idProcesso: number, idTipoMinuta: number): string {
        if (RouterStore.isPrd) {
            return this.config.urlMinuta + idProcesso + '/' + idTipoMinuta;
        }
        return this.config.urlMinutaGE + idProcesso + '/' + idTipoMinuta;
    }

    salvarUnidadePublicacao(idProcesso: number, idTipoMinuta: number): string {
        return this.config.urlBaseGE + 'api/processos/' + idProcesso + '/' + idTipoMinuta + '/salvar-unidade-publicacao';
    }

    salvarUnidadePublicaoLote(idProcesso: number): string {
        return this.config.urlBaseGE + 'api/processos/' + idProcesso + '/salvar-unidade-publicao-lote';
    }

    minutaPorSituacao(idProcesso: number, codSituacao: number): string {
        return this.config.urlMinutaGE + idProcesso + '?situacao=' + codSituacao;
    }

    //MIGRADO
    funcaoMagistrado(idProcesso: number, idTipoMinuta: number): string {
        if (RouterStore.isPrd) {
            return this.config.urlMinuta + idProcesso + '/' + idTipoMinuta + '/funcao';
        }
        return this.config.urlMinutaGE + idProcesso + '/' + idTipoMinuta + '/funcao';
    }

    validar(numeroMinuta: string): string {
        return this.config.urlMinutaGE + numeroMinuta + '/verificar';
    }

    tiposMinuta(idProcesso: number): string {
        return this.config.urlMinutaGE + idProcesso;
    }

    recuperaMinutaAssinatura(numeroMinuta: number) {
        return this.config.urlDadosMinutaAssinar + numeroMinuta;
    }

    recuperaMinutaAssinada(numeroMinuta: number) {
        return this.config.urlMinutaGE + numeroMinuta + '/assinada';
    }

    recuperaPreviewVersaoMinuta(versao: VersaoMinutaDto) {
        return this.config.urlDadosPreviewVersaoMinuta + versao.docId + '/' + versao.tipo + '/' + versao.extensao;
    }

    minutaEstaEmEdicaoExterna(numerosMinutas: number[]) {
        return `${this.config.urlMinutaEmEdicaoExterna}?numero=${numerosMinutas.join('&numero=')}`;
    }

    consultaVoto(idprocesso: number, idVoto: number) {
        return this.config.urlMinutaGE + 'voto/' + idprocesso + '/' + idVoto + '/consulta';
    }

    consultaIdVoto(idprocesso: number) {
        return this.config.urlMinutaGE + 'voto/' + idprocesso + '/recuperaId';
    }

    consultaVotoEmLote(_idsProcesso: number[]) {
        return this.config.urlMinutaGE + 'voto/consulta-liberacao';
    }

    //MIGRADO
    atualizaPlanilhaEmLote(_idsProcesso: number[]) {
        // if (RouterStore.isPrd) {
        //     return this.config.urlMinuta + 'voto/forcar-atualizar-planinha';
        // }
        return this.config.urlMinutaGE + '{SIGLA_GABINETE}/voto/forcar-atualizar-planinha';
    }

    forcaVistoLiberado(idProcesso: number, gabinete: string) {
        return this.config.urlProcessosGE + idProcesso + '/marcarVistoRealizado?gabinete=' + gabinete;
    }

    historicoSituacaoMinuta(numeroMinuta: number): string {
        return this.config.urlBaseGE + 'api/minuta/' + numeroMinuta + '/historico';
    }

    historicoAlteracaoSituacaoMinuta(apenasUltimaAlteracao: boolean): string {
        return this.config.urlBaseGE + 'api/minuta/historico-alteracao-situacao/' + apenasUltimaAlteracao;
    }

    listarVinculosPeticaoMinuta(numeroMinuta: number): string {
        return this.config.urlMinutaGE + 'peticao/' + numeroMinuta;
    }

    vincularPeticaoMinuta(numeroMinuta, idPeticao, idUnico) {
        const numeroMinutaSeguro = encodeURIComponent(String(numeroMinuta));
        const idPeticaoSeguro = encodeURIComponent(String(idPeticao));
        const idUnicoSeguro = encodeURIComponent(String(idUnico));
        return this.config.urlMinutaGE + 'peticao/vincular/' + numeroMinutaSeguro + '/peticao/' + idPeticaoSeguro + '/idUnico/' + idUnicoSeguro;
    }

    listarVersoes(numeroMinuta) {
        return this.config.urlMinutaGE + 'versoes/' + numeroMinuta;
    }

    baixarVersao(gedId, tipo, ext) {
        return this.config.urlMinutaGE + 'versoes/' + gedId + '/' + tipo + '/' + ext;
    }

    restaurarVersao(numeroMinuta, gedId, tipo, ext) {
        return this.config.urlMinutaGE + 'versoes/' + numeroMinuta + '/' + gedId + '/' + tipo + '/' + ext;
    }
}

export default new UrlsMinuta();
